import React from 'react';
import Styles from './AddButton.module.scss';
import { Button } from '@nextiva/next-ui';

const AddButton = ({ children, onClick }) => {
  return (
    <Button onClick={onClick} kind="success" className={Styles['addButton']}>
      {children}
    </Button>
  );
};

export default AddButton;
